export default "__VITE_ASSET__B16oq$qM__"